console.log('VariantRadios.js: File loaded, script execution started.');

// Define PUB_SUB_EVENTS only if it's not already defined
if (typeof PUB_SUB_EVENTS === 'undefined') {
  window.PUB_SUB_EVENTS = {
    cartUpdate: 'cart:update',
    quantityUpdate: 'quantity:update',
    variantChange: 'variant:changed',
    cartError: 'cart:error',
  };
  console.log('VariantRadios.js: PUB_SUB_EVENTS defined.');
} else {
  console.log('VariantRadios.js: PUB_SUB_EVENTS already defined, using existing.');
}

try {
  class VariantRadios extends HTMLElement {
    constructor() {
      super();
      console.log('VariantRadios: Constructor invoked.');
      this.currentVariant = null;
      this.productData = null;
    }

    connectedCallback() {
      console.log('VariantRadios: connectedCallback invoked.');
      this.addEventListener('change', this.onVariantChange);
      this.loadProductData();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onVariantChange);
    }

    loadProductData() {
      const productId = this.dataset.productId || this.closest('[data-product-id]')?.dataset.productId;
      if (!productId) {
        console.warn('VariantRadios: No product ID found.');
        return;
      }

      const scriptElement = document.getElementById(`ProductJSON-${productId}`);
      if (!scriptElement) {
        console.warn('VariantRadios: Product JSON script not found.');
        return;
      }

      try {
        this.productData = JSON.parse(scriptElement.textContent);
        console.log('VariantRadios: Product data loaded:', this.productData);
        
        // Set initial variant
        this.setInitialVariant();
      } catch (e) {
        console.error('VariantRadios: Error parsing product JSON:', e);
      }
    }

    setInitialVariant() {
      if (!this.productData?.variants) return;

      // Get current URL params
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');
      
      // Find initial variant
      let initialVariant;
      if (variantIdFromUrl) {
        initialVariant = this.productData.variants.find(v => v.id.toString() === variantIdFromUrl);
      }
      
      if (!initialVariant) {
        initialVariant = this.productData.variants.find(v => v.available) || this.productData.variants[0];
      }

      if (initialVariant) {
        console.log('VariantRadios: Setting initial variant:', initialVariant);
        this.currentVariant = initialVariant;
        this.updateSelectedOptions(initialVariant);
        this.publishVariantChange(initialVariant);
      }
    }

    onVariantChange = () => {
      console.log('VariantRadios: onVariantChange triggered.');
      const selectedOptions = this.getSelectedOptions();
      console.log('VariantRadios: Selected options:', selectedOptions);
      
      if (!this.productData?.variants) {
        console.warn('VariantRadios: No product data available.');
        return;
      }

      const matchingVariant = this.findMatchingVariant(selectedOptions);
      console.log('VariantRadios: Matching variant:', matchingVariant);

      if (matchingVariant && matchingVariant !== this.currentVariant) {
        this.currentVariant = matchingVariant;
        this.publishVariantChange(matchingVariant);
      }
    }

    getSelectedOptions() {
      const options = {};
      const selects = this.querySelectorAll('select[name^="options"]');
      const radios = this.querySelectorAll('input[type="radio"]:checked');
      
      // Handle select dropdowns
      selects.forEach(select => {
        const optionIndex = parseInt(select.name.replace('options[', '').replace(']', ''));
        if (select.value) {
          options[`option${optionIndex + 1}`] = select.value;
        }
      });

      // Handle radio buttons
      radios.forEach(radio => {
        const optionIndex = parseInt(radio.name.replace('options[', '').replace(']', ''));
        options[`option${optionIndex + 1}`] = radio.value;
      });

      console.log('VariantRadios: Collected options:', options);
      return options;
    }

    findMatchingVariant(selectedOptions) {
      if (!this.productData?.variants) return null;

      return this.productData.variants.find(variant => {
        return Object.keys(selectedOptions).every(key => {
          const optionValue = selectedOptions[key];
          const variantValue = variant[key];
          return optionValue === variantValue;
        });
      });
    }

    updateSelectedOptions(variant) {
      if (!variant) return;

      // Update selects
      const selects = this.querySelectorAll('select[name^="options"]');
      selects.forEach(select => {
        const optionIndex = parseInt(select.name.replace('options[', '').replace(']', ''));
        const optionValue = variant[`option${optionIndex + 1}`];
        if (optionValue) {
          select.value = optionValue;
        }
      });

      // Update radios
      const radios = this.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        const optionIndex = parseInt(radio.name.replace('options[', '').replace(']', ''));
        const optionValue = variant[`option${optionIndex + 1}`];
        radio.checked = radio.value === optionValue;
      });
    }

    publishVariantChange(variant) {
      console.log('VariantRadios: Publishing variant change:', variant);
      
      const event = new CustomEvent(PUB_SUB_EVENTS.variantChange, {
        detail: { variant },
        bubbles: true
      });

      this.dispatchEvent(event);
      document.dispatchEvent(event);
    }
  }

  if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', VariantRadios);
    console.log('VariantRadios.js: Custom element registered.');
  }

} catch (e) {
  console.error('VariantRadios.js: Critical error:', e);
}

console.log('VariantRadios.js: Script execution finished.');